module.exports = __webpack_public_path__ + "media/images/crypto/ethereum-60b941526c4d8e6c1840b6d77ed30079.png";